import { render, staticRenderFns } from "./postal-code.vue?vue&type=template&id=4cdfdc8b&"
import script from "./postal-code.vue?vue&type=script&lang=js&"
export * from "./postal-code.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports